import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyInformationSectionComponent } from '../../../sections//residential-for-sale/property-information-section/property-information-section.component';
import { PropertyFeaturesSectionComponent } from '../../../sections/residential-for-sale/property-features-section/property-features-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';
import { PropertySaleDetailsSectionComponent } from '../../../sections//residential-for-sale-agent/property-sale-details-section/property-sale-details-section.component';
import { PropertyOpenHomeTimesSectionComponent } from '../../../sections//residential-for-sale/property-open-home-times-section/property-open-home-times-section.component';
import { PropertyAgentContactDetailsSectionComponent } from '../../../sections/residential-for-sale-agent/property-agent-contact-details-section/property-agent-contact-details-section.component';
import { PropertyParkingSectionComponent } from '../../../sections/residential-for-sale/property-parking-section/property-parking-section.component';

@Component({
    templateUrl: './property-information-page.component.html',
    styleUrls: ['./property-information-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { 'data-variant': 'residential-for-sale-agent' },
    standalone: false
})
export class ResidentialForSaleAgentPropertyInformationComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyInformationSectionComponent, {
        read: PropertyInformationSectionComponent
    })
    propertyInformationSection: PropertyInformationSectionComponent;

    @ViewChild(PropertyFeaturesSectionComponent, {
        read: PropertyFeaturesSectionComponent
    })
    propertyFeaturesSectionComponent: PropertyFeaturesSectionComponent;

    @ViewChild(PropertySaleDetailsSectionComponent, {
        read: PropertySaleDetailsSectionComponent
    })
    propertySaleDetailsSectionComponent: PropertySaleDetailsSectionComponent;

    @ViewChild(PropertyOpenHomeTimesSectionComponent, {
        read: PropertyOpenHomeTimesSectionComponent
    })
    propertyOpenHomeTimesSection: PropertyOpenHomeTimesSectionComponent;

    @ViewChild(PropertyAgentContactDetailsSectionComponent, {
        read: PropertyAgentContactDetailsSectionComponent
    })
    propertyAgentContactDetailsSection: PropertyAgentContactDetailsSectionComponent;

    @ViewChild(PropertyParkingSectionComponent, {
        read: PropertyParkingSectionComponent
    })
    propertyParkingSectionComponent: PropertyParkingSectionComponent;
    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyInformation, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyInformationSection);
        super.registerSection(this.propertySaleDetailsSectionComponent);
        super.registerSection(this.propertyOpenHomeTimesSection);
        super.registerSection(this.propertyAgentContactDetailsSection);
        super.registerSection(this.propertyFeaturesSectionComponent);
        super.registerSection(this.propertyParkingSectionComponent);
    }
}
